import React from 'react';
import clsx from 'clsx';

import Typography from '@material-ui/core/Typography';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const Estrutura = ({ edicao }) => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-05" className={classes.title}>
                5. ESTRUTURA DA PROVA
            </Title>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>5.1</span>
                A {edicao}ª Olimpíada de Professores da OBMEP Mirim será realizada em fase única, mediante aplicação de prova objetiva. 
                A prova será formada por 20 (vinte) questões objetivas, com cinco opções de resposta (a, b, c, d, e).
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>5.2</span>
                A prova será elaborada por <span className={classes.bolder}>Comitê de Provas</span> especializado e experiente, responsável pela elaboração das provas da OBMEP, desde 2005, e das provas da 
                Olimpíada Mirim – OBMEP, desde 2022, garantindo qualidade técnica, rigor acadêmico e adequação ao perfil dos professores participantes.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>5.3</span> 
                A prova será realizada em Centros de Aplicação previamente definidos pelo <span className={classes.bolder}>IMPA</span>, com base no município selecionado pelo professor dentre os 
                municípios indicados pelo <span className={classes.bolder}>IMPA</span> na ficha de inscrição.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>5.4</span> 
                A aplicação da prova dar-se-á no dia <span className={clsx(classes.bolder, classes.underline)}>17 de outubro de 2026, às 14:30h (horário de Brasília)</span>, 
                conforme estipulado e disponível no Calendário Oficial da {edicao}ª Olimpíada de Professores da OBMEP Mirim (Anexo I).
            </Typography>
        </>
    )
}

export default Estrutura;
